import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { SORT_NONE } from '../../../../../common/constants';
import type { Column } from '../../../../../common/types';
import { getSortOrderConfig } from '../../../../../common/ui/header-cell/constants';
import {
	ColumnName,
	SortIcon,
	ContentContainer,
} from '../../../../../common/ui/header-cell/styled';
import WarningIndicator from '../../../../../common/ui/warning-indicator';

type Props = {
	column: Column;
};

const ReadOnlyTableHeaderCellContent = ({ column }: Props) => {
	const intl = useIntl();

	const { currentSorting: sortOrder = SORT_NONE, title, warningText } = column;

	const { getIcon, isIconPersistent } = getSortOrderConfig({
		sortOrder,
		intl,
	});

	return (
		<ContentContainer isIconPersistent={isIconPersistent}>
			{warningText && <WarningIndicator tooltip={warningText} />}
			<ColumnName>{title}</ColumnName>
			{isIconPersistent && <SortIcon isIconPersistent={isIconPersistent}>{getIcon()}</SortIcon>}
		</ContentContainer>
	);
};

export default ReadOnlyTableHeaderCellContent;
